import React from 'react';
import Picker from 'react-weui';
import TitleView from './titleview';
import Separator from './separator';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import { Form, FormCell, CellHeader, Label, Input, CellBody } from 'react-weui';
import 'weui';
import 'react-weui/build/packages/react-weui.css';

class DateQuestion extends React.Component {
	constructor(props) {
		super(props);
		this.onChangeDate = this.onChangeDate.bind(this);

		this.state = {
			calendarShown: false
		}

		this.toggleCalendar = this.toggleCalendar.bind(this);
	}

	toggleCalendar() {
		this.setState({ calendarShown: !this.state.calendarShown });
	}

	componentDidMount() {
		const content = this.props.answer.content;

		if (content == null) {
			// Set default selected date
			this.onChangeDate(moment());
		}
	}

	get selectedDate() {
		const content = this.props.answer.content;

		if (content == null) {
			return moment();
		}

		const type = this.props.question.question_type;

		if (type === 'datetime') {
			return moment(content, 'YYYY-MM-DDTHH:mm:ss');
		} else if (type === 'date') {
			return moment(content, 'YYYY-MM-DD');
		} else if (type === 'time') {
			return moment(content, 'HH:mm:ss');
		}
	}

	onChangeDate(date) {
		const type = this.props.question.question_type;
		let content;
		if (type === 'datetime') {
			content = date.format('YYYY-MM-DDTHH:mm:ss');
		} else if (type === 'date') {
			content = date.format('YYYY-MM-DD');
		} else if (type === 'time') {
			content = date.format('HH:mm:ss');
		}

		const answer = this.props.answer;
		answer.content = content;
		this.props.onChangeAnswer(answer);
	}

	renderCell(value) {
		const type = this.props.question.question_type;
		if (type === 'datetime') {
			return (
				<FormCell>
	        <CellHeader>
	            <Label>Select Time</Label>
	        </CellHeader>
	        <CellBody>
	            <Input type="datetime-local" defaultValue={value} 
	            onChange={ e => this.onChangeDate(moment(e.target.value, 'YYYY-MM-DDTHH:mm')) } />
	        </CellBody>
	    </FormCell> );
		} else if (type === 'date') {
			return (
				<FormCell>
	        <CellHeader>
	            <Label>Select Date</Label>
	        </CellHeader>
	        <CellBody>
	            <Input type="date" defaultValue={value} placeholder="" 
	            onChange={ e => this.onChangeDate(moment(e.target.value, 'YYYY-MM-DD')) } />
	        </CellBody>
	    	</FormCell> );
		} else if (type === 'time') {
			return (
				<FormCell>
	        <CellHeader>
	            <Label>Select time</Label>
	        </CellHeader>
	        <CellBody>
	            <Input type="time" defaultValue={value} placeholder=""
	            onChange={ e => this.onChangeDate(moment(e.target.value, 'HH:mm')) } />
	        </CellBody>
	    	</FormCell> );
		}
	}

	renderInput() {
		const type = this.props.question.question_type;
	
		let dateText;
		
		const date = this.selectedDate;
		if (type === 'date') {
		 	dateText = date.format('YYYY-MM-DD');
		} else if (type === 'time') {
			dateText = date.format('HH:mm');
		} else if (type === 'datetime') {
			dateText = date.format('YYYY-MM-DDTHH:mm');
		}	
		
		const cell = this.renderCell(dateText);

		return ( 
			<Form>
				{cell}
	    </Form>
    );
	}

	render() {
		const question = this.props.question;
		const input = this.renderInput();

		return (
			<div style={{
				position: 'relative',
				width: '100%',
				height: '100%'
			}}>
				<TitleView title={question.question_text}/>
				{input}
			</div>
		);
	}
}

export default DateQuestion;


// WEBPACK FOOTER //
// ./src/components/datequestion.jsx